import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=5aabfedd&scoped=true&lang=html"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=5aabfedd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aabfedd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aabfedd')) {
      api.createRecord('5aabfedd', component.options)
    } else {
      api.reload('5aabfedd', component.options)
    }
    module.hot.accept("./EditProfile.vue?vue&type=template&id=5aabfedd&scoped=true&lang=html", function () {
      api.rerender('5aabfedd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/EditProfile.vue"
export default component.exports